// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Fira_Sans_6ddda2', '__Fira_Sans_Fallback_6ddda2'"},"className":"__className_6ddda2"};